import { Box, TextField } from '@mui/material';
import { forwardRef, memo } from 'react';
import { NumericFormat } from 'react-number-format';
import { useBoundStore } from 'useStore';
import useExchangeRateData from '../../Queries/exchangeRateQuery';

const NumericFormatCustom = forwardRef(function NumericFormatCustom(
	props,
	ref
) {
	const { onChange, id, ...other } = props;

	const prefix = ['gmv_usd', 'gmv_local', 'profit', 'pvp'].includes(
		id.split('-')[1]
	)
		? '$'
		: '';
	const suffix = ['mg'].includes(id.split('-')[1]) ? '%' : '';

	return (
		<NumericFormat
			{...other}
			getInputRef={ref}
			value={''}
			onValueChange={(values) => {
				onChange({
					target: {
						name: props.name,
						value: values.value,
					},
				});
			}}
			decimalScale={id.split('-')[1] !== 'tsu' ? 1 : 0}
			thousandSeparator
			valueIsNumericString
			maxLength={9}
			allowNegative={id.split('-')[1] === 'mg'}
			prefix={prefix}
			suffix={suffix}
			style={{ textAlign: 'center' }}
		/>
	);
});

const EditNumberInput = memo(({ id, value, field, hasFocus, row, month }) => {
	const editedRows = useBoundStore((state) => state.forecastEditedRows);
	const addForecastEditedRow = useBoundStore(
		(state) => state.addForecastEditedRow
	);
	const placeholder = ['gmv', 'profit', 'pvp'].includes(field.split('-')[0])
		? '$0.00'
		: ['mg'].includes(field.split('-')[0])
		? '0.00%'
		: '0';

	const fieldId = field.split('-')[1];

	const editedRow = editedRows[id];

	const currentRow = editedRow ?? row;

	const currentMonth = currentRow?.[month];

	const currentValue = currentMonth?.[fieldId];

	const exchangeRateQuery = useExchangeRateData();
	const tc = exchangeRateQuery.data?.[0]?.[month];

	const handleValueChange = (event) => {
		const newValue = event.target.value || 0; // The new value entered by the user

		addForecastEditedRow({
			id,
			month,
			tc,
			row: {
				...currentRow,
				[month]: {
					...currentMonth,
					[fieldId]:
						fieldId !== 'tsu'
							? Number.parseFloat(newValue)
							: Number.parseInt(newValue),
				},
			},
		});
	};

	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				width: '100%',
				height: '100%',
				backgroundColor: 'white',
			}}
		>
			<TextField
				label=""
				placeholder={placeholder}
				type="text"
				defaultValue={currentValue}
				value={currentValue}
				onChange={handleValueChange}
				name={field}
				id={field}
				sx={{
					textAlign: 'center',
					'& .MuiInputBase-input': {
						padding: '0 !important',
					},
				}}
				InputProps={{
					inputComponent: NumericFormatCustom,
					disableUnderline: true,
					style: { textAlign: 'center' },
				}}
				inputRef={(input) => input && hasFocus && input.focus()}
				variant="standard"
			/>
		</Box>
	);
});

export default EditNumberInput;
